import * as React from "react";

import type { IconProps } from "./types";

export const DamperIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M1.6 16H0V0H1.6M16 0H14.4V16H16M12.192 2.672L8.992 5.872C8.54415 5.65811 8.041 5.58832 7.55184 5.67225C7.06268 5.75618 6.61157 5.98969 6.26063 6.34063C5.90969 6.69157 5.67618 7.14268 5.59225 7.63184C5.50832 8.121 5.57811 8.62415 5.792 9.072L2.592 12.272L3.728 13.408L6.928 10.208C7.37585 10.4219 7.879 10.4917 8.36816 10.4078C8.85732 10.3238 9.30843 10.0903 9.65937 9.73937C10.0103 9.38843 10.2438 8.93732 10.3278 8.44816C10.4117 7.959 10.3419 7.45585 10.128 7.008L13.328 3.808L12.192 2.672Z"
        fill={color}
      />
    </svg>
  ),
);

export default DamperIcon;
